import { useContext, useRef } from "react";
import "./manuallyCreateTimetable.css";
import { useEffect, useState } from "react";
import {
  DatePickerComponent,
  TimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import axios from "../../../axios";
import CreateSuccessfulTimeTable from "../PopUp/Create_successful/CreateSuccessfulChannel";
import { SubStdSelContext } from "../../../SubStdSelContext";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useParams } from "react-router-dom";
import DeleteUpdate from "./DeleteUpdate";
import UpdateSupplements from "./UpdateSupplements";
import OverLap from "../PopUp/Create_successful/OverLap";
import { toast } from "react-toastify";
import DeleteSuccessfulTimetableByDate from "./DeleteSuccessfulTimetableByDate";
import CreateTimeTable from "./createTimeTable";
import { Trash2 } from "lucide-react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Checkbox,
  Collapse,
  Switch,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Description, ExpandMore, LiveTv } from "@mui/icons-material";

import {
  Paper,
  Stack,
  Typography,
  Chip,
  Tooltip,
  Box,
  Button,
  Card,
  CardContent,
  Tabs,
  Tab,
  Alert,
  AlertTitle,
  FormControl,
  Select as MuiSelect,
  MenuItem,
  IconButton,
  Divider,
  Grid,
  Fade,
  Grow,
  CssBaseline,
} from "@mui/material";
import {
  Add,
  ArrowBack,
  CloudUpload,
  Publish,
  AddCircle,
  EditCalendar,
  DeleteForever,
  WarningAmber,
  EventNote,
  AccessTime,
  Schedule,
  Class as ClassIcon,
  School,
  Person,
  CalendarMonth,
  ArrowForwardIos,
  LiveTv as LiveTvIcon,
} from "@mui/icons-material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const orangeTheme = createTheme({
  palette: {
    primary: {
      main: "#f77f00",
      light: "#ffb74d",
      dark: "#e65100",
      contrastText: "#fff",
    },
    secondary: { main: "#2d3436", light: "#636e72" },
    background: { default: "#f8f9fa", paper: "#ffffff" },
    error: { main: "#d32f2f", light: "#ef5350" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: { fontWeight: 700, letterSpacing: "-0.5px" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, textTransform: "none", fontWeight: 600 },
      },
    },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 10 } } },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 16, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" },
      },
    },
  },
});

export default function ManualyCreateTimetable({ leftSidebarSize }) {
  const navigate = useNavigate();
  const { isEditable } = useParams();
  const [standardChoice, setStandardChoice] = useState([]);
  const [userStandardChoice, setUserStandardChoice] = useState(null);
  const [sectionChoice, setSectionChoice] = useState([]);
  const [userSubjectChoice, setUserSubjectChoice] = useState(null);
  const [getAllSubject, SetGetAllSubject] = useState([]);
  const [subIndex, setSubIndex] = useState(null);
  const [specialLecture, setSpecialLecture] = useState([]);
  const [lecture, setLecture] = useState([]);
  const [generalLecture, setGeneralLecture] = useState([]);
  const [timetableSuccess, setTimetableSuccess] = useState(false);
  const [updateSupplemnts, setUpdateSupplemnts] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [timeTableDeletedByDate, setTimeTableDeletedByDate] = useState(false);
  const [timeTableDeleteStartDate, setTimeTableDeleteStartDate] =
    useState(null);
  const [timeTableDeleteEndDate, setTimeTableDeleteEndDate] = useState(null);
  const [timeTableDeleteDay, setTimeTableDeleteDay] = useState("");
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isDeletingTimeTable, setIsDeletingTimeTable] = useState(false);
  const [showDeletTimeTableByDatePopup, setShowDeletTimeTableByDatePopup] =
    useState(false);
  const [newUpdateLacture, setNewUpdatedLacture] = useState([]);
  const [newUpdateSpecialLacture, setNewUpdateSpecialLacture] = useState([]);
  const [newUpdateGeneralLacture, setNewUpdateGeneralLacture] = useState([]);
  const { secSelectedOption, stdSelectedOption, teacherDCM } =
    useContext(SubStdSelContext);
  const [createNew, setCreateNew] = useState(false);
  const [updateExt, setUpdateExisting] = useState(false);
  const [dateUpdateExt, setDateUpdateExt] = useState(null);
  const [delThisLecture, setDelThisLecture] = useState(true);
  const [delSeriesLecture, setDelSeriesLecture] = useState(false);
  const [delclick, setDelClick] = useState(false);
  const [delDetails, setDelDetails] = useState({});
  const [errorMsg, setErrMsg] = useState("Something went wrong!");
  const [openPopup, setOpenPopup] = useState(false);
  const [todayDay, setTodayDay] = useState([]);
  const [timeIssues, setTimeIssues] = useState({});
  const [uploadLecture, setUploadLecture] = useState(true);
  const [noLectMsg, setNoLectMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const lectureListRef = useRef(null);
  const [updateAccordionOpen, setUpdateAccordionOpen] = useState(true);

  const [activeTab, setActiveTab] = useState(0);
  const CTRole_Information = localStorage.getItem("role_as_class_teacher");
  const CoRole_Information = localStorage.getItem("role_as_co_ordinator");
  const general_role = localStorage.getItem("general_role");
  const jsonRole_CTinformation = JSON.parse(CTRole_Information);
  const jsonRole_Coinformation = JSON.parse(CoRole_Information);
  const jsonRole_Geinformation = JSON.parse(general_role);
  const academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let timetableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  // Students list state — kisi bhi existing state ke paas add kar
  const [studentsList, setStudentsList] = useState([]);

  // Students fetch effect — kisi bhi existing useEffect ke paas
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const res = await axios.get(
          `/api/v1/school/student/get/school/${schoolId}`,
        );
        const list = res?.data?.data || [];
        const filtered = list.filter(
          (s) =>
            s?.standard?.id === stdSelectedOption &&
            s?.section?.id === secSelectedOption,
        );
        setStudentsList(filtered);
      } catch (err) {
        console.log("Error fetching students:", err);
      }
    };
    if (stdSelectedOption && secSelectedOption) fetchStudents();
  }, [stdSelectedOption, secSelectedOption, schoolId]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setNewUpdateGeneralLacture([]);
    setNewUpdatedLacture([]);
    setNewUpdateSpecialLacture([]);
    setTimeTableDeletedByDate(false);
    setCreateNew(false);
    setUploadLecture(false);
    setUpdateExisting(false);
    setDateUpdateExt(null);
    setNoLectMsg("");

    if (newValue === 0) {
      setUploadLecture(true);
    } else if (newValue === 1) {
      setCreateNew(true);
      handleDeaultFields();
    } else if (newValue === 2) {
      setUpdateExisting(true);
      handleDeaultFieldsUpdate();
    } else if (newValue === 3) {
      setTimeTableDeletedByDate(true);
      handleDeaultFieldsForDeleteTimeTableByDate();
    }
  };

  // const [fields, setFields] = useState([
  //   {
  //     data: {
  //       id: 0,
  //       name: "",
  //       start_time: "",
  //       end_time: "",
  //       classType: "",
  //       subject_id: null,
  //       teacher_id: null,
  //       day: selectedDay,
  //       start_date: "",
  //       end_date: "",
  //     },
  //   },
  // ]);

  const [fields, setFields] = useState([
    {
      data: {
        id: 0,
        name: "",
        start_time: "",
        end_time: "",
        classType: "",
        subject_id: null,
        teacher_id: null,
        day: selectedDay,
        start_date: "",
        end_date: "",
        // 🔥 LIVE LECTURE FIELDS
        isLiveLecture: false,
        liveClassName: "",
        liveDescription: "",
        liveStudentMode: "ALL",
        liveSelectedStudents: [],
      },
    },
  ]);

  const resetUpdatedLectures = () => {
    setNewUpdatedLacture([]);
    setNewUpdateSpecialLacture([]);
    setNewUpdateGeneralLacture([]);
  };

  const today = new Date();
  new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  function isDataIncomplete() {
    if (fields.length > 0) {
      let res = fields.some((field) => {
        let data = field.data;

        // Existing checks
        for (const element in data) {
          if (data.classType === "special" || data.classType === "lecture") {
            if (element === "subject_id" && data[element] == null) return true;
            // if (element === "teacher_id" && data[element] == null) return true;
          }
          // Skip live fields if live is OFF
          if (
            !data.isLiveLecture &&
            (element === "liveClassName" ||
              element === "liveDescription" ||
              element === "liveSelectedStudents")
          ) {
            continue;
          }
          if (data[element] === "") return true;
        }

        // 🔥 LIVE LECTURE MANDATORY CHECK
        if (data.isLiveLecture) {
          if (!data.liveClassName?.trim()) return true;
          if (!data.liveDescription?.trim()) return true;
          if (
            data.liveStudentMode === "SELECTED" &&
            (!data.liveSelectedStudents ||
              data.liveSelectedStudents.length === 0)
          ) {
            return true;
          }
        }

        return false;
      });
      setDisable(res);
    } else {
      setDisable(true);
    }
  }
  useEffect(() => {
    isDataIncomplete();
  }, [fields]);

  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);
    const days = dateObject.getDay();
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    setTodayDay(dayNames[days]);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const fetchTimetable = async (date) => {
    console.log("date in efethc timetabel", date);
    setNoLectMsg("");
    try {
      if (!academicYearId || !timetableSessionId) {
        toast.error(
          "There are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      setFields([]);
      setLoading(true);
      let res = await axios.get(
        `/api/v1/timetable/getTimetableByDate/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${stdSelectedOption}/sectionId/${secSelectedOption}/timetableSessionId/${timetableSessionId}/date/${date}`,
      );

      if (date && res.data.data.length === 0) {
        setNoLectMsg("No Lectures found for this date");
        setLoading(false);
        return false;
      }

      if (res.data.data.length > 0) {
        const timetableData = res.data.data[0];
        const schedules = timetableData.schedules[0];
        if (
          schedules.lectures.length === 0 &&
          schedules.special_lectures.length === 0 &&
          schedules.general_categories.length === 0
        ) {
          setNoLectMsg("No Lectures found for this date");
          setLoading(false);
          return false;
        }

        console.log("schedules", schedules);
        const lecturesPromises = schedules.lectures.map(
          async (lecture, index) => {
            let teacher1 = lecture.teacher == null ? [] : [lecture.teacher];
            // let teacher1 = await helper(lecture.subject.id);
            return {
              id: index,
              data: {
                id: lecture?.id,
                name: lecture?.name,
                start_time: lecture?.start_time,
                end_time: lecture?.end_time,
                classType: "lecture",
                subject_id: lecture?.subject?.id,
                teacher_id: lecture?.teacher?.id,
                day: lecture?.day,
                start_date: lecture?.date,
                end_date: lecture?.date,
                supplements: lecture?.supplements || null,
              },
              teacher: teacher1,
            };
          },
        );

        const formattedLectures = await Promise.all(lecturesPromises);
        setLecture(formattedLectures);
        const SpecialLecturesPromises = schedules.special_lectures.map(
          async (specialLecture, index) => {
            let teacher1 =
              specialLecture.teacher == null ? [] : [specialLecture.teacher];
            // let teacher1 = await helper(specialLecture.subject.id);
            return {
              id: index + formattedLectures.length, // Adjust index for uniqueness
              data: {
                id: specialLecture?.id,
                name: specialLecture?.name,
                start_time: specialLecture?.start_time,
                end_time: specialLecture?.end_time,
                subject_id: specialLecture?.subject?.id,
                teacher_id: specialLecture?.teacher?.id,
                day: specialLecture?.day,
                start_date: specialLecture?.date,
                end_date: specialLecture?.date,
                classType: "special",
                supplements: lecture?.supplements || null,
              },
              teacher: teacher1,
            };
          },
        );
        const formattedSpecialLectures = await Promise.all(
          SpecialLecturesPromises,
        );
        setSpecialLecture(formattedSpecialLectures);
        const formattedGeneralCategories = schedules.general_categories.map(
          (generalCategory, index) => {
            return {
              id:
                index +
                formattedLectures.length +
                formattedSpecialLectures.length, // Adjust index for uniqueness
              data: {
                id: generalCategory?.id,
                name: generalCategory?.name,
                start_time: generalCategory?.start_time,
                end_time: generalCategory?.end_time,
                classType: "general",
                day: generalCategory?.day,
                start_date: generalCategory?.date,
                end_date: generalCategory?.date,
                supplements: lecture?.supplements || null,
                // Include other properties as needed
              },
            };
          },
        );
        setGeneralLecture(formattedGeneralCategories);
        const allFormattedData = [
          ...formattedLectures,
          ...formattedSpecialLectures,
          ...formattedGeneralCategories,
        ];
        setFields(allFormattedData);
        if (allFormattedData.length > 0) {
          setUpdateAccordionOpen(false);
        }
        // 🔥 ADD THIS
        setTimeout(() => {
          allFormattedData.forEach((field, index) => {
            if (field?.data?.subject_id) {
              handleGetTimeTableManual(field.data.subject_id, index);
            }
          });
        }, 0);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching timetable:", error);
    }
  };

  const handleGetTimeTableManual = async (subjectId, index) => {
    try {
      if (!subjectId) return;

      // 1️⃣ Subject teachers
      const res = await axios.get(
        `/api/v1/school/teacher/getTeacherInfoBySubjectStandardSectionId?standard_id=${stdSelectedOption}&section_id=${secSelectedOption}&subject_id=${subjectId}&timetableSession_id=${timetableSessionId}`,
      );

      const subjectTeachers = res?.data?.data || [];

      // 2️⃣ All teachers (for CT + CC)
      const allRes = await axios.get(
        `/api/v1/school/teacher/get/school/${schoolId}`,
      );

      const allTeachersFromSchool = allRes?.data?.data || [];

      const teacherMap = new Map();

      // ✅ STEP 1: subject teachers
      subjectTeachers.forEach((t) => {
        teacherMap.set(t.id, {
          ...t,
          role: ["Subject Teacher"],
        });
      });

      // ✅ STEP 2: ONLY CT + CC of SAME class & section
      allTeachersFromSchool.forEach((t) => {
        const isClass = t?.role_as_class_teacher?.some(
          (r) =>
            r.standard_id?.id === stdSelectedOption &&
            r.section_id?.id === secSelectedOption,
        );

        const isCoordinator = t?.role_as_co_ordinator?.some(
          (r) =>
            r.standard_id?.id === stdSelectedOption &&
            r.section_id?.id === secSelectedOption,
        );

        // ❌ skip others
        if (!isClass && !isCoordinator) return;

        if (teacherMap.has(t.id)) {
          // merge roles
          let roles = teacherMap.get(t.id).role || [];

          if (isClass && !roles.includes("Class Teacher"))
            roles.push("Class Teacher");

          if (isCoordinator && !roles.includes("Coordinator"))
            roles.push("Coordinator");

          teacherMap.set(t.id, {
            ...teacherMap.get(t.id),
            role: roles,
          });
        } else {
          // new CT / CC
          let roles = [];
          if (isClass) roles.push("Class Teacher");
          if (isCoordinator) roles.push("Coordinator");

          teacherMap.set(t.id, {
            id: t.id,
            name: t.name,
            employeeId: t.employee_id,
            role: roles,
          });
        }
      });

      const finalTeachers = Array.from(teacherMap.values());

      // ✅ FINAL UPDATE
      setFields((prev) => {
        const updated = [...prev];

        if (updated[index]) {
          updated[index] = {
            ...updated[index],
            teacher: finalTeachers,
          };
        }

        return updated;
      });
    } catch (err) {
      console.log("error", err);
    }
  };
  useEffect(() => {
    if (dateUpdateExt !== null) {
      let date = formatDate(dateUpdateExt);
      fetchTimetable(date);
    }
  }, [dateUpdateExt]);

  const handleAddField = () => {
    const newFields = [...fields];
    newFields.push({
      data: {
        id: fields.length,
        name: "",
        start_time: "",
        end_time: "",
        classType: "",
        subject_id: null,
        teacher_id: null,
        day: selectedDay,
        // 🔥 LIVE LECTURE FIELDS
        isLiveLecture: false,
        liveClassName: "",
        liveDescription: "",
        liveStudentMode: "ALL",
        liveSelectedStudents: [],
      },
    });
    setFields(newFields);
    requestAnimationFrame(() => {
      lectureListRef.current?.scrollTo({
        top: lectureListRef.current.scrollHeight,
        behavior: "smooth",
      });
    });
  };

  useEffect(() => {
    try {
      const helper = async () => {
        let res = await axios.get(
          `/api/v1/school/standardId/${stdSelectedOption}/sectionId/${secSelectedOption}/getSubjects`,
        );
        const data = res?.data?.data;
        const subjectSource =
          data?.subjectConfigurations?.length > 0
            ? data.subjectConfigurations.map((item) => item.subject)
            : data.subjects;
        SetGetAllSubject(subjectSource);
      };
      helper();
    } catch (error) {
      console.log(error);
    }
  }, [updateExt, createNew]);

  const handleGetTimeTable = async () => {
    try {
      if (subIndex === null || !userSubjectChoice) return;

      // 🔹 1. Subject Teachers API
      const res = await axios.get(
        `/api/v1/school/teacher/getTeacherInfoBySubjectStandardSectionId?standard_id=${stdSelectedOption}&section_id=${secSelectedOption}&subject_id=${userSubjectChoice}&timetableSession_id=${timetableSessionId}`,
      );

      const subjectTeachers = res?.data?.data || [];

      // 🔹 2. All Teachers API (with roles)
      const allRes = await axios.get(
        `/api/v1/school/teacher/get/school/${schoolId}`,
      );

      const allTeachersFromSchool = allRes?.data?.data || [];

      // 🔥 3. Create map for fast lookup
      const teacherMap = new Map();

      // ✅ Step 1: Add subject teachers first
      subjectTeachers.forEach((t) => {
        teacherMap.set(t.id, {
          ...t,
          role: ["Subject Teacher"], // default role
        });
      });

      // ✅ Step 2: Merge roles from full teacher data
      allTeachersFromSchool.forEach((t) => {
        const isSameClass = t?.role_as_class_teacher?.some(
          (r) =>
            r.standard_id?.id === stdSelectedOption &&
            r.section_id?.id === secSelectedOption,
        );

        const isCoordinator = t?.role_as_co_ordinator?.some(
          (r) =>
            r.standard_id?.id === stdSelectedOption &&
            r.section_id?.id === secSelectedOption,
        );

        if (!isSameClass && !isCoordinator) return;

        if (teacherMap.has(t.id)) {
          // ✅ already exists → merge roles
          const existing = teacherMap.get(t.id);

          let roles = existing.role || [];

          if (isSameClass && !roles.includes("Class Teacher")) {
            roles.push("Class Teacher");
          }

          if (isCoordinator && !roles.includes("Coordinator")) {
            roles.push("Coordinator");
          }

          teacherMap.set(t.id, {
            ...existing,
            role: roles,
          });
        } else {
          // ✅ new teacher (not subject teacher)
          let roles = [];

          if (isSameClass) roles.push("Class Teacher");
          if (isCoordinator) roles.push("Coordinator");

          teacherMap.set(t.id, {
            id: t.id,
            name: t.name,
            employeeId: t.employee_id,
            role: roles,
          });
        }
      });

      // 🔥 FINAL ARRAY
      const finalTeachers = Array.from(teacherMap.values());

      console.log("FINAL TEACHERS =>", finalTeachers);

      // 🔹 Update UI
      const updatedFields = [...fields];

      if (updatedFields[subIndex]) {
        updatedFields[subIndex] = {
          ...updatedFields[subIndex],
          teacher: finalTeachers,
        };
      }

      setFields(updatedFields);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    handleGetTimeTable();
  }, [userSubjectChoice, stdSelectedOption, secSelectedOption, subIndex]);

  const handleRemoveField = (index, field) => {
    // fields se index ke hisaab se remove karna
    const newFields = [...fields];
    newFields.splice(index, 1);
    setFields(newFields);

    // ab alag-alag lecture arrays me bhi splice karna
    if (field.data.classType === "special") {
      setSpecialLecture((prevArray) => {
        const updated = [...prevArray];
        updated.splice(index, 1);
        return updated;
      });
    } else if (field.data.classType === "lecture") {
      setLecture((prevArray) => {
        const updated = [...prevArray];
        updated.splice(index, 1);
        return updated;
      });
    } else if (field.data.classType === "general") {
      setGeneralLecture((prevArray) => {
        const updated = [...prevArray];
        updated.splice(index, 1);
        return updated;
      });
    }
  };

  const addObjectToArrays = (object) => {
    const idExists = (arr) => arr.some((item) => item.id === object.id);
    if (object.data.classType === "special" && !idExists(specialLecture)) {
      setSpecialLecture((prevArray) => [...prevArray, object]);
    } else if (object.data.classType === "lecture" && !idExists(lecture)) {
      setLecture((prevArray) => [...prevArray, object]);
    } else if (
      object.data.classType === "general" &&
      !idExists(generalLecture)
    ) {
      setGeneralLecture((prevArray) => [...prevArray, object]);
    }
  };

  const parseTimeToMinutes = (timeString) => {
    if (!timeString) {
      toast.error("Please enter time in correct format!!");
      return;
    }
    if (timeString.length !== 4) {
      // console.error("Invalid time format. Expected 'HHMM'.");
      toast.error("Invalid time format. Expected 'HHMM'.");
      return -1; // Or handle the error as appropriate
    }

    const hours = parseInt(timeString.substring(0, 2), 10);
    const minutes = parseInt(timeString.substring(2, 4), 10);

    return hours * 60 + minutes;
  };

  const [updatedFieldIndex, setUpdatedFieldIndex] = useState(null);

  useEffect(() => {
    let field = fields[updatedFieldIndex];
    if (updatedFieldIndex !== null) {
      handleInputChange(
        field.id,
        "classType",
        field.data.classType,
        updatedFieldIndex,
      );
    }
  }, [updatedFieldIndex]);

  const handleInputChange = (id, property, value, index) => {
    const newFields = [...fields];
    const field = newFields[index];

    if (field) {
      if (property === "start_date") {
        field.data.start_date = value;
        field.data.end_date = value;
      }
      if (property === "end_time") {
        const startTime = field.data.start_time;
        const endTime = value;
        const startMinutes = parseTimeToMinutes(startTime);
        const endMinutes = parseTimeToMinutes(endTime);
        if (startMinutes >= endMinutes) {
          if (startMinutes === endMinutes) {
            setTimeIssues((prev) => ({ ...prev, [field.id]: true }));
          } else {
            setTimeIssues((prev) => ({ ...prev, [field.id]: true }));
          }
          // Return early to prevent setting an invalid end_time
          return;
        } else {
          setTimeIssues((prev) => ({ ...prev, [field.id]: false }));
        }
      }
      field.data[property] = value;
      if (field.data.classType !== undefined) {
        if (field.data.classType === "lecture") {
          setNewUpdatedLacture((prev) => {
            let prevData = prev.filter((val) => val.id !== field.data.id);
            return [...prevData, field.data];
          });
        }

        if (field.data.classType === "special") {
          setNewUpdateSpecialLacture((prev) => {
            let prevData = prev.filter((val) => val.id !== field.data.id);
            return [...prevData, field.data];
          });
        }

        if (field.data.classType === "general") {
          setNewUpdateGeneralLacture((prev) => {
            let prevData = prev.filter((val) => val.id !== field.data.id);
            return [...prevData, field.data];
          });
        }
      }
      // if (field.data.classType !== undefined) {
      //   if (field.data.classType === "lecture") {

      //     setNewUpdatedLacture((prev) => {
      //       console.log("prev>>>>", prev);

      //       // let prevData = prev.filter((val) => val.id !== field.data.id);
      //     });
      //   }

      //   if (field.data.classType === "special") {
      //     setNewUpdateSpecialLacture((prev) => {
      //       // let prevData = prev.filter((val) => val.id !== field.data.id);
      //       return [field.data];
      //     });
      //   }

      //   if (field.data.classType === "general") {
      //     setNewUpdateGeneralLacture((prev) => {
      //       // let prevData = prev.filter((val) => val.id !== field.data.id);
      //       return [field.data];
      //     });
      //   }
      // }

      setFields(newFields);
      const updatedObject = newFields[index];
      addObjectToArrays(updatedObject);
    }
  };
  function fetchTime(dateString) {
    if (!dateString) {
      toast.error("Please enter time in correct format!!");
      return;
    }

    const date = new Date(dateString);
    const options = { hour12: false };
    const time = date.toLocaleTimeString("en-US", options);
    const [hours, minutes] = time.split(":");
    const formattedTime = `${hours}${minutes}`;
    return formattedTime;
  }

  useEffect(() => {
    const uniqueStandards = [];
    jsonRole_CTinformation?.forEach((obj) => {
      if (!uniqueStandards.some((item) => item.id === obj.standard_id.id)) {
        uniqueStandards.push(obj.standard_id);
      }
    });
    jsonRole_Coinformation?.forEach((obj) => {
      if (!uniqueStandards.some((item) => item.id === obj.standard_id.id)) {
        uniqueStandards.push(obj.standard_id);
      }
    });
    jsonRole_Geinformation?.forEach((obj) => {
      if (!uniqueStandards.some((item) => item.id === obj.standard_id.id)) {
        uniqueStandards.push(obj.standard_id);
      }
    });
    setStandardChoice(uniqueStandards);
  }, []);

  useEffect(() => {
    const uniqueSections = [];
    jsonRole_CTinformation?.forEach((obj) => {
      if (
        obj.standard_id.id === userStandardChoice &&
        !uniqueSections.some((item) => item.id === obj.section_id.id)
      ) {
        uniqueSections.push(obj.section_id);
      }
    });
    jsonRole_Coinformation?.forEach((obj) => {
      if (
        obj.standard_id.id === userStandardChoice &&
        !uniqueSections.some((item) => item.id === obj.section_id.id)
      ) {
        uniqueSections.push(obj.section_id);
      }
    });
    jsonRole_Geinformation?.forEach((obj) => {
      if (
        obj.standard_id.id === userStandardChoice &&
        !uniqueSections.some((item) => item.id === obj.section_id.id)
      ) {
        uniqueSections.push(obj.section_id);
      }
    });
    setSectionChoice(uniqueSections);
  }, [userStandardChoice]);

  const handlePublish = async () => {
    let newAllArray = [];
    if (updateExt) {
      const removedExtraGeneralLacture = newUpdateGeneralLacture.filter(
        (val) => val.classType == "general",
      );
      setNewUpdateGeneralLacture(removedExtraGeneralLacture);
      const removedExtraLacture = newUpdateLacture.filter(
        (val) => val.classType == "lecture",
      );

      setNewUpdatedLacture(removedExtraLacture);
      const removedExtraSpecialLacture = newUpdateSpecialLacture.filter(
        (val) => val.classType == "special",
      );
      setNewUpdateSpecialLacture(removedExtraSpecialLacture);
      newAllArray = [
        ...newUpdateGeneralLacture,
        ...newUpdateSpecialLacture,
        ...newUpdateLacture,
      ];
    } else {
      setLactureData();
      newAllArray = [
        ...newUpdateGeneralLacture,
        ...newUpdateSpecialLacture,
        ...newUpdateLacture,
      ];
      if (newAllArray.length !== fields.length) {
        setLactureData();
      }
    }

    //Checking Lacture is empty
    if (newAllArray.length === 0) {
      toast.error("Please update lecture");
      return false;
    }

    // Checking updated Lacture is not overlap
    if (newAllArray.length > 0) {
      let isLactureOverlapping = checkLectureOverlap(newAllArray);

      if (isLactureOverlapping.overlap) {
        toast.error(isLactureOverlapping.message);
        return false;
      }
    }

    let lectureAlreadyEnded = false;
    let expiredLectureNames = [];

    for (let item of newUpdateLacture) {
      const endTimeUpdate = parseInt(item?.end_time);
      const now = new Date();
      const currentTimeUpdate = now.getHours() * 100 + now.getMinutes();

      const lectureDate = new Date(item?.start_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      lectureDate.setHours(0, 0, 0, 0);

      const isToday = lectureDate.getTime() === today.getTime();

      if (isToday && endTimeUpdate < currentTimeUpdate) {
        lectureAlreadyEnded = true;
        expiredLectureNames.push(item?.name || "");
      }
    }

    if (updateExt && isEditable === "true" && lectureAlreadyEnded) {
      toast.error(
        `Cannot update this lecture "${expiredLectureNames}" that has already ended. `,
      );
      return;
    }
    const allLectureWithoutId = newUpdateLacture?.map(
      ({ id, ...rest }) => rest,
    );
    const allSpecialLectureWithoutId = newUpdateSpecialLacture?.map(
      ({ id, ...rest }) => rest,
    );
    const allGeneralLectureWithoutId = newUpdateGeneralLacture?.map(
      ({ id, ...rest }) => rest,
    );

    let schedules = [
      {
        general_categories: updateExt
          ? newUpdateGeneralLacture
          : allGeneralLectureWithoutId,
        special_lectures: updateExt
          ? newUpdateSpecialLacture
          : allSpecialLectureWithoutId,
        lectures: updateExt ? newUpdateLacture : allLectureWithoutId,
      },
    ];
    let acdId = JSON.parse(localStorage.getItem("academicYearId"));
    let schId = JSON.parse(localStorage.getItem("schoolId"));
    let tmSId = JSON.parse(localStorage.getItem("timeTableSessionId"));
    let tmId = localStorage.getItem("TimetableId");
    let body = {
      academic_year_id: acdId,
      school_id: schId,
      standard_id: stdSelectedOption,
      section_id: secSelectedOption,
      timetable_session_id: tmSId,
      schedules: schedules,
    };

    setLoading(true);
    setIsLoading(true);

    if (updateExt && isEditable === "true") {
      try {
        let res = await axios.put(`/api/v1/timetable/update/${tmId}`, body);
        // toast.success(res.data.message);
        if (res.status === 200) {
          if (updateExt) {
            setUpdateSupplemnts(true);
            await fetchTimetable(formatDate(dateUpdateExt));
            resetUpdatedLectures();
          }
        }
      } catch (error) {
        console.log("error", error);
        setOpenPopup(true);
        setErrMsg(error.response.data.message);
        setLoading(false);
      } finally {
        setLoading(false);
        setIsLoading(false); // ✅ MOST IMPORTANT
      }
    } else {
      try {
        let res = await axios.post(`/api/v1/timetable/create`, body);
        // toast.success(res.data.message);
        if (res.status === 201) {
          setTimetableSuccess(true);
        }
      } catch (error) {
        setLoading(false);
        if (error) {
          setErrMsg(error.response.data.message);
          setOpenPopup(true);
          setIsLoading(false);
        }
      } finally {
        setCreateNew(true);
        // handleDeaultFields();
        setIsLoading(false);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setFields((prev) =>
      prev.map((field) => {
        const { start_date, end_date } = field.data;

        if (!start_date || !end_date) return field;

        const start = new Date(start_date);
        const end = new Date(end_date);

        let day = "All";

        // Same date => auto select actual weekday
        if (start.toDateString() === end.toDateString()) {
          const dayNames = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];

          day = dayNames[start.getDay()];
        }

        return {
          ...field,
          data: {
            ...field.data,
            day,
          },
        };
      }),
    );
  }, [fields.map((f) => `${f.data.start_date}-${f.data.end_date}`).join("|")]);
  function checkLectureOverlap(lectures) {
    // Helper function to convert time string (like "1310") to minutes since start of day
    function timeToMinutes(time) {
      console.log("time", time);
      if (!time) {
        toast.error("Please enter time in correct format!!");
        return;
      }
      const hours = parseInt(time.slice(0, 2), 10);
      const minutes = parseInt(time.slice(2), 10);
      return hours * 60 + minutes;
    }

    // Helper function to check if two time ranges overlap
    function isTimeOverlap(start1, end1, start2, end2) {
      return Math.max(start1, start2) < Math.min(end1, end2);
    }

    // Helper function to check if two date ranges overlap
    function isDateOverlap(startDate1, endDate1, startDate2, endDate2) {
      return startDate1 <= endDate2 && startDate2 <= endDate1;
    }

    // Loop through each lecture and compare it with the other lectures
    for (let i = 0; i < lectures.length; i++) {
      const lecture1 = lectures[i];

      // Convert dates to Date objects
      const startDate1 = new Date(lecture1.start_date);
      const endDate1 = new Date(lecture1.end_date);
      const startTime1 = timeToMinutes(lecture1.start_time);
      const endTime1 = timeToMinutes(lecture1.end_time);

      for (let j = i + 1; j < lectures.length; j++) {
        const lecture2 = lectures[j];

        // If the lectures are on the same day of the week
        if (lecture1.day === lecture2.day) {
          const startDate2 = new Date(lecture2.start_date);
          const endDate2 = new Date(lecture2.end_date);
          const startTime2 = timeToMinutes(lecture2.start_time);
          const endTime2 = timeToMinutes(lecture2.end_time);

          // Check if the date ranges overlap
          if (isDateOverlap(startDate1, endDate1, startDate2, endDate2)) {
            // Check if the time ranges overlap
            if (isTimeOverlap(startTime1, endTime1, startTime2, endTime2)) {
              return {
                overlap: true,
                message: `Lecture "${lecture1.name}" overlaps with lecture "${lecture2.name}" on a ${lecture1.day}.`,
              };
            }
          }
        }
      }
    }

    return {
      overlap: false,
      message: "No lectures overlap.",
    };
  }

  function setLactureData() {
    setNewUpdatedLacture((prev) => {
      let prevData = fields.filter((val) => val.data.classType == "lecture");
      prevData = prevData.map((val) => val.data);
      return prevData;
    });

    setNewUpdateSpecialLacture((prev) => {
      let prevData = fields.filter((val) => val.data.classType == "special");
      prevData = prevData.map((val) => val.data);
      return prevData;
    });

    setNewUpdateGeneralLacture((prev) => {
      let prevData = fields.filter((val) => val.data.classType == "general");
      prevData = prevData.map((val) => val.data);
      return prevData;
    });
  }

  const handleDeaultFields = () => {
    setFields([
      {
        data: {
          id: 0,
          name: "",
          start_time: "",
          end_time: "",
          classType: "",
          subject_id: null,
          teacher_id: null,
          day: selectedDay,
          start_date: null, //new Date().toISOString().split('T')[0],
          end_date: null, //new Date().toISOString().split('T')[0]
        },
      },
    ]);
    setGeneralLecture([]);
    setLecture([]);
    setSpecialLecture([]);
    SetGetAllSubject([]);
  };
  const handleDeaultFieldsUpdate = () => {
    setFields([]);
    setGeneralLecture([]);
    setLecture([]);
    setSpecialLecture([]);
    SetGetAllSubject([]);
    setLoading(false);
  };

  const handleDeaultFieldsForDeleteTimeTableByDate = () => {
    setFields([]);
    setGeneralLecture([]);
    setLecture([]);
    setSpecialLecture([]);
    SetGetAllSubject([]);
    setLoading(false);
  };

  function convertTo12HourFormat(time) {
    // Extract hours and minutes from the input
    let hours = Math.floor(time / 100);
    let minutes = time % 100;

    // Determine AM or PM suffix
    let period = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12 || 12;

    // Format minutes to always be two digits
    minutes = minutes < 10 ? "0" + minutes : minutes;

    // Return formatted time
    return `${hours}:${minutes} ${period}`;
  }

  function formatDateForLecture(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  async function handleDeleteLactureByDate() {
    if (
      !(
        timeTableDeleteStartDate &&
        timeTableDeleteEndDate &&
        timeTableDeleteDay
      )
    ) {
      toast.error("All fiels are required!");
      return false;
    }

    let acdId = JSON.parse(localStorage.getItem("academicYearId"));
    let schId = JSON.parse(localStorage.getItem("schoolId"));
    let tmSId = JSON.parse(localStorage.getItem("timeTableSessionId"));
    let tmId = localStorage.getItem("TimetableId");
    let body = {
      id: tmId,
      academic_year_id: acdId,
      school_id: schId,
      standard_id: stdSelectedOption,
      section_id: secSelectedOption,
      timetable_session_id: tmSId,
      start_date: formatDateForLecture(timeTableDeleteStartDate),
      end_date: formatDateForLecture(timeTableDeleteEndDate),
      day: timeTableDeleteDay,
    };

    setIsDeletingTimeTable(true);
    try {
      const response = await axios.delete(
        "/api/v1/timetable/deleteLecturesByDateRange",
        { data: body },
      );
      setIsConfirmation(false);
      setIsDeletingTimeTable(false);
    } catch (error) {
      console.log("error : ", error);
      toast.error(error.response.data.message);
      setIsDeletingTimeTable(false);
      setShowDeletTimeTableByDatePopup(false);
    }
  }

  const getSupplementIcons = (supplements) => {
    if (!supplements) return [];

    const icons = [];

    if (supplements.pre_read) {
      icons.push({ name: "pre_read", icon: "/images/preRead.svg" });
    }
    if (supplements.activity) {
      icons.push({ name: "activity", icon: "/images/activity.svg" });
    }
    if (supplements.homework) {
      icons.push({ name: "homework", icon: "/images/Homework 2.svg" });
    }
    if (supplements.assessment) {
      icons.push({ name: "assessment", icon: "/images/Assessment 2.svg" });
    }
    // if (supplements.attachments && supplements.attachments.length > 0) {
    //   icons.push({ name: "attachments", icon: "images/attachment.svg" });
    // }

    return icons;
  };

  useEffect(() => {
    if (!timeTableDeleteStartDate || !timeTableDeleteEndDate) return;

    const start = new Date(timeTableDeleteStartDate);
    const end = new Date(timeTableDeleteEndDate);

    // Same date -> auto select that weekday
    if (start.toDateString() === end.toDateString()) {
      const dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      setTimeTableDeleteDay(dayNames[start.getDay()]);
    } else {
      // Different dates -> All
      setTimeTableDeleteDay("All");
    }
  }, [timeTableDeleteStartDate, timeTableDeleteEndDate]);

  return (
    <ThemeProvider theme={orangeTheme}>
      <CssBaseline />
      <Box
        className={`${leftSidebarSize === 70 ? "expand" : "collapsess"} orange-scrollBar`}
        sx={{
          maxHeight: "100vh",
          overflowY: "auto",
          bgcolor: "#f8f9fa",
          minHeight: "100vh",
          p: { xs: 1 },
        }}
      >
        {/* ─── Action Tabs ─── */}
        {isEditable === "true" && (
          <Card
            sx={{
              mb: 2,
              borderRadius: 3,
              boxShadow: "0 2px 12px rgba(247,127,0,0.08)",
              display: "flex",
              justifyContent: "space-between",
              padding: 1,
              alignItems: "center",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <School color="primary" />
              <Typography variant="h5" color="primary.main" fontWeight={800}>
                {isEditable === "true"
                  ? "Manage Timetable"
                  : "Time Table Template"}
              </Typography>
            </Stack>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
              sx={{
                minHeight: 56,
                "& .MuiTabs-flexContainer": { gap: 1, px: 1 },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  minHeight: 44,
                  px: 3,
                },
                "& .Mui-selected": {
                  bgcolor: "#FFF3E0",
                  color: "#e65100 !important",
                },
              }}
            >
              <Tab
                icon={<CloudUpload sx={{ fontSize: 18 }} />}
                iconPosition="start"
                label="Upload Lecture"
              />
              <Tab
                icon={<AddCircle sx={{ fontSize: 18 }} />}
                iconPosition="start"
                label="Add Lectures"
              />
              <Tab
                icon={<EditCalendar sx={{ fontSize: 18 }} />}
                iconPosition="start"
                label="Update Lectures"
              />
              <Tab
                icon={<DeleteForever sx={{ fontSize: 18 }} />}
                iconPosition="start"
                label="Delete Lectures"
              />
            </Tabs>
          </Card>
        )}

        {/* ─── Main Content Card ─── */}
        <Card
          sx={{
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.06)",
            overflow: "visible",
          }}
        >
          {/* Top Action Bar */}
          <Box
            sx={{
              p: 3,
              pb: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<ArrowBack />}
              onClick={() => {
                if (isEditable === "true") {
                  localStorage.setItem("fromFeed", "false");
                } else {
                  localStorage.setItem("fromFeed", "true");
                }
                navigate("/lactureManagement");
              }}
              sx={{ borderRadius: 3, textTransform: "none", fontWeight: 600 }}
            >
              Back
            </Button>

            {timeTableDeletedByDate ? (
              <Button
                variant="contained"
                color="error"
                disabled={
                  !(
                    timeTableDeleteStartDate &&
                    timeTableDeleteEndDate &&
                    timeTableDeleteDay
                  )
                }
                onClick={() => {
                  setShowDeletTimeTableByDatePopup(true);
                  setIsConfirmation(true);
                }}
                sx={{ borderRadius: 3, fontWeight: 600, px: 4 }}
              >
                Delete
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handlePublish}
                disabled={disable || isLoading}
                startIcon={isLoading ? null : <Publish />}
                sx={{
                  borderRadius: 3,
                  px: 5,
                  py: 1,
                  fontWeight: 700,
                  boxShadow:
                    disable || isLoading
                      ? "none"
                      : "0 4px 16px rgba(247,127,0,0.35)",
                  bgcolor: disable || isLoading ? "#ffb74d" : undefined,
                }}
              >
                {isLoading ? "Publishing..." : "Publish Timetable"}
              </Button>
            )}
          </Box>

          <CardContent sx={{ pt: 1 }}>
            {/* ─── Update Mode: Date Picker ─── */}
            {updateExt && (
              <Fade in={updateExt}>
                <Accordion
                  expanded={updateAccordionOpen}
                  onChange={(_, isExpanded) =>
                    setUpdateAccordionOpen(isExpanded)
                  }
                  sx={{
                    mb: 1,
                    borderRadius: 3,
                    overflow: "hidden",
                    border: "1px solid #ffe0b2",
                    boxShadow: "0 2px 12px rgba(247,127,0,0.08)",
                    "&:before": { display: "none" },
                    "&.Mui-expanded": { margin: 0, mb: 4 },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore sx={{ color: "#f77f00" }} />}
                    sx={{
                      bgcolor: "#fff8e1",
                      px: 3,
                      py: 1,
                      "&.Mui-expanded": { minHeight: 48 },
                      cursor: "pointer",
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Avatar
                        sx={{ width: 32, height: 32, bgcolor: "#f77f00" }}
                      >
                        <EventNote sx={{ fontSize: 18, color: "white" }} />
                      </Avatar>
                      <Box>
                        <Typography fontWeight={700} color="#2d3436">
                          Update Lectures
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {updateAccordionOpen
                            ? "Select date to load & edit timetable"
                            : dateUpdateExt
                              ? `Loaded: ${new Date(dateUpdateExt).toLocaleDateString("en-GB")}`
                              : "Click to expand"}
                        </Typography>
                      </Box>
                    </Stack>
                  </AccordionSummary>

                  <AccordionDetails sx={{ p: 3, bgcolor: "#ffffff" }}>
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      spacing={3}
                      alignItems="center"
                      sx={{ mb: 3 }}
                    >
                      <Typography
                        fontWeight={600}
                        color="text.secondary"
                        sx={{ minWidth: 100 }}
                      >
                        Select Date:
                      </Typography>
                      <Box sx={{ minWidth: 260 }}>
                        <DatePickerComponent
                          allowEdit={false}
                          min={today}
                          isDateDisabled={disablePastDates}
                          onChange={(e) => {
                            if (e.target.value) {
                              const today = new Date();
                              const selectedDate = new Date(e.target.value);
                              today.setHours(0, 0, 0, 0);
                              selectedDate.setHours(0, 0, 0, 0);
                              if (selectedDate < today) {
                                alert(
                                  "Selected date cannot be earlier than today.",
                                );
                                e.target.value = today;
                                return;
                              }
                            }
                            if (!e.target.value) {
                              setLoading(false);
                              handleDeaultFieldsUpdate();
                            } else {
                              setDateUpdateExt(e.target.value);
                              setNewUpdatedLacture([]);
                            }
                          }}
                          className="e-calendar customColor"
                          id="datepickerLive"
                          placeholder="Choose a date"
                        />
                      </Box>
                    </Stack>

                    <Alert
                      severity="warning"
                      icon={<WarningAmber />}
                      sx={{ borderRadius: 2 }}
                    >
                      <AlertTitle sx={{ fontWeight: 700 }}>
                        Important Notice
                      </AlertTitle>
                      <Typography variant="body2">
                        All the{" "}
                        <Box
                          component="span"
                          sx={{ fontWeight: "bold", color: "primary.main" }}
                        >
                          Supplements
                        </Box>{" "}
                        and{" "}
                        <Box
                          component="span"
                          sx={{ fontWeight: "bold", color: "primary.main" }}
                        >
                          Live lectures
                        </Box>{" "}
                        associated to updated lectures will be{" "}
                        <Box
                          component="span"
                          sx={{ fontWeight: "bold", color: "error.main" }}
                        >
                          removed
                        </Box>
                        . However, they can be viewed under{" "}
                        <Box
                          component="span"
                          sx={{ fontWeight: "bold", color: "error.main" }}
                        >
                          "Assignments and Assessments"
                        </Box>
                        .
                      </Typography>
                    </Alert>

                    {noLectMsg && (
                      <Box
                        sx={{
                          mt: 3,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Chip
                          label={noLectMsg}
                          color="error"
                          variant="filled"
                          sx={{
                            fontWeight: 700,
                            px: 2,
                            py: 2.5,
                            fontSize: "1rem",
                          }}
                        />
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Fade>
            )}

            {/* ─── Delete Mode ─── */}
            {timeTableDeletedByDate && (
              <Fade in={timeTableDeletedByDate}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: 3,
                    bgcolor: "#fafafa",
                    border: "1px solid #eeeeee",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 3,
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <DeleteForever color="error" /> Delete Lectures by Date
                    Range
                  </Typography>

                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 1, fontWeight: 600 }}
                      >
                        From Date
                      </Typography>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <DatePickerComponent
                          allowEdit={false}
                          className=" w-100"
                          value={timeTableDeleteStartDate}
                          isDateDisabled={disablePastDates}
                          onChange={(e) => {
                            setTimeTableDeleteStartDate(e.target.value);
                            setTimeTableDeleteEndDate(e.target.value);
                          }}
                        />
                        <CalendarMonth color="action" />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 1, fontWeight: 600 }}
                      >
                        To Date
                      </Typography>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <DatePickerComponent
                          allowEdit={false}
                          min={timeTableDeleteStartDate}
                          className=" w-100"
                          isDateDisabled={disablePastDates}
                          value={timeTableDeleteEndDate}
                          onChange={(e) =>
                            setTimeTableDeleteEndDate(e.target.value)
                          }
                        />
                        <CalendarMonth color="action" />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 1, fontWeight: 600 }}
                      >
                        Select Day
                      </Typography>
                      <FormControl fullWidth>
                        <MuiSelect
                          value={timeTableDeleteDay}
                          onChange={(e) =>
                            setTimeTableDeleteDay(e.target.value)
                          }
                          displayEmpty
                          sx={{ borderRadius: 2, bgcolor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Day
                          </MenuItem>
                          <MenuItem value="Monday">Monday</MenuItem>
                          <MenuItem value="Tuesday">Tuesday</MenuItem>
                          <MenuItem value="Wednesday">Wednesday</MenuItem>
                          <MenuItem value="Thursday">Thursday</MenuItem>
                          <MenuItem value="Friday">Friday</MenuItem>
                          <MenuItem value="Saturday">Saturday</MenuItem>
                          <MenuItem value="Sunday">Sunday</MenuItem>
                          <MenuItem value="All">All</MenuItem>
                        </MuiSelect>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Alert severity="info" sx={{ mt: 4, borderRadius: 2 }}>
                    <Typography variant="body2">
                      Delete operation will remove all the lectures for above
                      date periods. All supplements associated to deleted
                      lectures will be removed, however they can be viewed under
                      "Assignments and Assessments".
                    </Typography>
                  </Alert>
                </Paper>
              </Fade>
            )}

            {/* ─── Lectures List (Create / Update) ─── */}
            {(createNew || updateExt) && (
              <Box
                ref={lectureListRef}
                className="orange-scrollBar"
                sx={{
                  maxHeight: createNew ? "54vh" : "44vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  pr: 1,
                }}
              >
                {fields.length > 0 ? (
                  <Stack spacing={3}>
                    {fields.map((field, index) => (
                      <Grow
                        in={true}
                        key={field.id}
                        timeout={300 + index * 100}
                      >
                        <Paper
                          elevation={2}
                          sx={{
                            borderRadius: 3,
                            overflow: "hidden",
                            border: "1px solid",
                            borderColor: timeIssues[field.id]
                              ? "error.light"
                              : "divider",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                              borderColor: timeIssues[field.id]
                                ? "error.main"
                                : "primary.light",
                            },
                            position: "relative",
                          }}
                        >
                          <CardContent sx={{ p: { xs: 2, md: 3 }, pt: 4 }}>
                            {/* Update Mode: Supplements + Delete */}
                            {updateExt && (
                              <Box
                                sx={{
                                  mb: 2,
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "flex-start",
                                }}
                              >
                                {field.data.supplements ? (
                                  <Paper
                                    elevation={1}
                                    sx={{
                                      p: 2,
                                      borderRadius: 2,
                                      bgcolor: "#fff3e0",
                                      border: "1px solid #ffe0b2",
                                      flex: 1,
                                      mr: 2,
                                    }}
                                  >
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      flexWrap="wrap"
                                      useFlexGap
                                      alignItems="center"
                                    >
                                      <Typography
                                        variant="subtitle2"
                                        color="error"
                                        fontWeight={700}
                                        sx={{
                                          whiteSpace: "nowrap",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 0.5,
                                        }}
                                      >
                                        <WarningAmber fontSize="small" />{" "}
                                        Supplements Added:
                                      </Typography>
                                      {getSupplementIcons(
                                        field.data.supplements,
                                      ).map((sup, idx) => (
                                        <Stack
                                          key={idx}
                                          direction="row"
                                          spacing={0.5}
                                          alignItems="center"
                                          sx={{
                                            bgcolor: "white",
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 2,
                                            border: "1px solid #ffe0b2",
                                          }}
                                        >
                                          <img
                                            src={sup.icon}
                                            alt={sup.name}
                                            style={{ width: 18, height: 18 }}
                                          />
                                          <Typography
                                            variant="caption"
                                            fontWeight={600}
                                          >
                                            {sup.name}
                                          </Typography>
                                        </Stack>
                                      ))}
                                      {field.data.supplements.bbb_lecture && (
                                        <Stack
                                          direction="row"
                                          spacing={0.5}
                                          alignItems="center"
                                          sx={{
                                            bgcolor: "white",
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 2,
                                            border: "1px solid #ffcdd2",
                                          }}
                                        >
                                          <LiveTvIcon
                                            color="error"
                                            fontSize="small"
                                          />
                                          <Typography
                                            variant="caption"
                                            fontWeight={600}
                                          >
                                            Live Lecture
                                          </Typography>
                                        </Stack>
                                      )}
                                    </Stack>
                                  </Paper>
                                ) : (
                                  <Box />
                                )}
                                <Tooltip title="Delete Lecture">
                                  <IconButton
                                    color="error"
                                    onClick={() => {
                                      setDelClick(true);
                                      setDelDetails(field);
                                    }}
                                    sx={{
                                      bgcolor: "#ffebee",
                                      "&:hover": {
                                        bgcolor: "#ef9a9a",
                                        color: "white",
                                      },
                                    }}
                                  >
                                    <Trash2 size={18} />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            )}

                            {/* Create Mode: Date & Day Row */}
                            {!updateExt && (
                              <Grid
                                container
                                spacing={2}
                                sx={{ mb: 3 }}
                                alignItems="center"
                              >
                                <Grid item xs={12} md={3}>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    fontWeight={600}
                                    sx={{
                                      mb: 0.5,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <CalendarMonth fontSize="small" />
                                    From Date
                                  </Typography>

                                  <FormControl fullWidth>
                                    <DatePickerComponent
                                      className="w-100"
                                      value={
                                        fields[index]?.data?.start_date
                                          ? new Date(
                                              fields[index].data.start_date,
                                            )
                                          : null
                                      }
                                      min={today}
                                      isDateDisabled={disablePastDates}
                                      onChange={(e) => {
                                        if (!e.target.value) {
                                          const newFields = [...fields];
                                          newFields[index].data.start_date = "";
                                          newFields[index].data.end_date = "";
                                          setFields(newFields);
                                          return;
                                        }

                                        const selectedDate = new Date(
                                          e.target.value,
                                        );
                                        selectedDate.setHours(0, 0, 0, 0);

                                        const todayDate = new Date();
                                        todayDate.setHours(0, 0, 0, 0);

                                        const formattedDate =
                                          selectedDate < todayDate
                                            ? formatDate(todayDate)
                                            : formatDate(selectedDate);

                                        const newFields = [...fields];
                                        newFields[index].data.start_date =
                                          formattedDate;
                                        newFields[index].data.end_date =
                                          formattedDate;
                                        setFields(newFields);

                                        const updatedObject = newFields[index];
                                        addObjectToArrays(updatedObject);
                                      }}
                                    />
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    fontWeight={600}
                                    sx={{
                                      mb: 0.5,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <CalendarMonth fontSize="small" />
                                    To Date
                                  </Typography>

                                  <FormControl fullWidth>
                                    <DatePickerComponent
                                      className="w-100"
                                      value={
                                        fields[index]?.data?.end_date
                                          ? new Date(
                                              fields[index].data.end_date,
                                            )
                                          : null
                                      }
                                      min={
                                        fields[index]?.data?.start_date
                                          ? new Date(
                                              fields[index].data.start_date,
                                            )
                                          : today
                                      }
                                      isDateDisabled={disablePastDates}
                                      onChange={(e) => {
                                        if (!e.target.value) {
                                          const newFields = [...fields];
                                          newFields[index].data.start_date = "";
                                          newFields[index].data.end_date = "";
                                          setFields(newFields);
                                          return;
                                        }

                                        const selectedDate = new Date(
                                          e.target.value,
                                        );
                                        selectedDate.setHours(0, 0, 0, 0);

                                        const startDate = fields[index]?.data
                                          ?.start_date
                                          ? new Date(
                                              fields[index].data.start_date,
                                            )
                                          : null;

                                        if (
                                          startDate &&
                                          selectedDate < startDate
                                        ) {
                                          toast.error(
                                            "End date cannot be before start date",
                                          );
                                          return;
                                        }

                                        const formattedDate =
                                          formatDate(selectedDate);

                                        const newFields = [...fields];
                                        newFields[index].data.end_date =
                                          formattedDate;
                                        setFields(newFields);

                                        const updatedObject = newFields[index];
                                        addObjectToArrays(updatedObject);
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    fontWeight={600}
                                    sx={{
                                      mb: 0.5,
                                      display: "block",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <EventNote fontSize="small" /> Select Day
                                  </Typography>
                                  <FormControl fullWidth size="small">
                                    <MuiSelect
                                      value={field.data.day}
                                      onChange={(e) => {
                                        handleInputChange(
                                          field.id,
                                          "day",
                                          e.target.value,
                                          index,
                                        );
                                        setLactureData();
                                      }}
                                      displayEmpty
                                      sx={{ borderRadius: 2, bgcolor: "white" }}
                                    >
                                      <MenuItem value="" disabled>
                                        Select Day
                                      </MenuItem>
                                      <MenuItem value="Monday">Monday</MenuItem>
                                      <MenuItem value="Tuesday">
                                        Tuesday
                                      </MenuItem>
                                      <MenuItem value="Wednesday">
                                        Wednesday
                                      </MenuItem>
                                      <MenuItem value="Thursday">
                                        Thursday
                                      </MenuItem>
                                      <MenuItem value="Friday">Friday</MenuItem>
                                      <MenuItem value="Saturday">
                                        Saturday
                                      </MenuItem>
                                      <MenuItem value="Sunday">Sunday</MenuItem>
                                      <MenuItem value="All">All</MenuItem>
                                    </MuiSelect>
                                  </FormControl>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={3}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                  }}
                                >
                                  {timeIssues[field.id] && (
                                    <Alert
                                      severity="error"
                                      sx={{
                                        py: 0,
                                        px: 1,
                                        borderRadius: 2,
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      Time Issue: Start must be before End
                                    </Alert>
                                  )}
                                  {fields.length > 1 && !updateExt && (
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      size="small"
                                      startIcon={<Trash2 size={16} />}
                                      onClick={() =>
                                        handleRemoveField(index, field)
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        ml: timeIssues[field.id] ? 1 : 0,
                                      }}
                                    >
                                      Remove
                                    </Button>
                                  )}
                                </Grid>
                              </Grid>
                            )}

                            <Divider
                              sx={{
                                mb: 3,
                                borderColor: timeIssues[field.id]
                                  ? "error.light"
                                  : "#eeeeee",
                              }}
                            />

                            {/* Form Fields */}
                            <Grid container spacing={3}>
                              {/* Row 1: Title + Times */}
                              <Grid item xs={12} md={4}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight={600}
                                  sx={{
                                    mb: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <ClassIcon fontSize="small" /> Lecture Title
                                </Typography>
                                <input
                                  id="input_Select_title"
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter lecture title..."
                                  value={field.data.name}
                                  maxLength={30}
                                  onChange={(e) =>
                                    handleInputChange(
                                      field.id,
                                      "name",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "10px 14px",
                                    borderRadius: 10,
                                    border: "1px solid #e0e0e0",
                                    fontSize: "0.95rem",
                                    transition: "all 0.2s",
                                    outline: "none",
                                  }}
                                  onFocus={(e) =>
                                    (e.target.style.borderColor = "#f77f00")
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.borderColor = "#e0e0e0")
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight={600}
                                  sx={{
                                    mb: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <AccessTime fontSize="small" /> From Time
                                </Typography>
                                <Box
                                  sx={{
                                    "& .e-input-group": {
                                      borderRadius: "10px !important",
                                      border: "1px solid #e0e0e0 !important",
                                    },
                                  }}
                                >
                                  <TimePickerComponent
                                    id="input_Select_time_inside"
                                    format="hh:mm a"
                                    placeholder="From Time"
                                    allowEdit={true}
                                    {...(fields[index]?.data?.start_date &&
                                    new Date(
                                      fields[index]?.data?.start_date,
                                    ).toDateString() ===
                                      new Date().toDateString()
                                      ? { min: new Date() }
                                      : {})}
                                    value={
                                      field.data.start_time
                                        ? convertTo12HourFormat(
                                            field.data.start_time,
                                          )
                                        : null
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        field.id,
                                        "start_time",
                                        fetchTime(e.target.value),
                                        index,
                                      )
                                    }
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight={600}
                                  sx={{
                                    mb: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Schedule fontSize="small" /> To Time
                                </Typography>
                                <Box
                                  sx={{
                                    "& .e-input-group": {
                                      borderRadius: "10px !important",
                                      border: "1px solid #e0e0e0 !important",
                                    },
                                  }}
                                >
                                  <TimePickerComponent
                                    id="input_Select_time_inside"
                                    format="hh:mm a"
                                    placeholder="To Time"
                                    allowEdit={true}
                                    value={
                                      field.data.end_time
                                        ? convertTo12HourFormat(
                                            field.data.end_time,
                                          )
                                        : null
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        field.id,
                                        "end_time",
                                        fetchTime(e.target.value),
                                        index,
                                      )
                                    }
                                  />
                                </Box>
                              </Grid>

                              {/* Row 2: Type + Subject + Teacher */}
                              <Grid item xs={12} md={4}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight={600}
                                  sx={{
                                    mb: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <ClassIcon fontSize="small" /> Class Type
                                </Typography>
                                <FormControl fullWidth size="small">
                                  <MuiSelect
                                    value={field.data.classType}
                                    disabled={field.data.classType && updateExt}
                                    onChange={(e) => {
                                      if (!updateExt) {
                                        handleInputChange(
                                          field.id,
                                          "classType",
                                          e.target.value,
                                          index,
                                        );
                                      }
                                    }}
                                    displayEmpty
                                    sx={{
                                      borderRadius: 2,
                                      bgcolor:
                                        field.data.classType && updateExt
                                          ? "#f5f5f5"
                                          : "white",
                                      "& .Mui-disabled": {
                                        color: "text.primary",
                                        fontWeight: 600,
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Type
                                    </MenuItem>
                                    {/* <MenuItem value="special">
                                      Special Lecture
                                    </MenuItem> */}
                                    <MenuItem value="lecture">
                                      Academic Lecture
                                    </MenuItem>
                                    <MenuItem value="general">
                                      Non-Academic Lecture
                                    </MenuItem>
                                  </MuiSelect>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight={600}
                                  sx={{
                                    mb: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <School fontSize="small" /> Subject
                                </Typography>
                                <FormControl fullWidth size="small">
                                  <MuiSelect
                                    value={field.data.subject_id ?? "null"}
                                    onChange={(e) => {
                                      handleInputChange(
                                        field.id,
                                        "subject_id",
                                        e.target.value === "null"
                                          ? null
                                          : e.target.value,
                                        index,
                                      );
                                      if (field?.teacher !== undefined) {
                                        field.teacher = [];
                                      }
                                      setUserSubjectChoice(e.target.value);
                                      setSubIndex(index);
                                    }}
                                    displayEmpty
                                    sx={{ borderRadius: 2, bgcolor: "white" }}
                                  >
                                    <MenuItem value="null" disabled>
                                      Select Subject
                                    </MenuItem>
                                    {getAllSubject.map((obj) => (
                                      <MenuItem key={obj.id} value={obj.id}>
                                        {obj.name}
                                      </MenuItem>
                                    ))}
                                  </MuiSelect>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight={600}
                                  sx={{
                                    mb: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Person fontSize="small" /> Teacher
                                </Typography>
                                <FormControl fullWidth size="small">
                                  <MuiSelect
                                    value={field.data.teacher_id ?? "null"}
                                    onChange={(e) =>
                                      handleInputChange(
                                        field.id,
                                        "teacher_id",
                                        e.target.value === "null"
                                          ? null
                                          : e.target.value,
                                        index,
                                      )
                                    }
                                    displayEmpty
                                    sx={{ borderRadius: 2, bgcolor: "white" }}
                                  >
                                    <MenuItem value="null" disabled>
                                      Select Teacher
                                    </MenuItem>
                                    {field?.teacher?.map((obj) => (
                                      <MenuItem key={obj.id} value={obj.id}>
                                        {obj.role
                                          ? `⭐ ${obj.role.join(" + ")} (${obj.name})`
                                          : `${obj?.name} | Code: ${obj?.teacherCode || obj?.employeeId}`}
                                      </MenuItem>
                                    ))}
                                  </MuiSelect>
                                </FormControl>
                              </Grid>

                              {/* ─── Live Lecture Configuration ─── */}
                              {/* <Grid item xs={12}>
                                <Box
                                  sx={{
                                    mt: 1,
                                    p: 2.5,
                                    borderRadius: 3,
                                    bgcolor: field.data.isLiveLecture
                                      ? "#fff8e1"
                                      : "#fafafa",
                                    border: "2px solid",
                                    borderColor: field.data.isLiveLecture
                                      ? "#ffb74d"
                                      : "#eeeeee",
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Avatar
                                        sx={{
                                          width: 40,
                                          height: 40,
                                          bgcolor: field.data.isLiveLecture
                                            ? "#f77f00"
                                            : "#e0e0e0",
                                          transition: "all 0.3s",
                                        }}
                                      >
                                        <LiveTv
                                          sx={{
                                            fontSize: 22,
                                            color: "white",
                                          }}
                                        />
                                      </Avatar>
                                      <Box>
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight={700}
                                          color={
                                            field.data.isLiveLecture
                                              ? "#e65100"
                                              : "#2d3436"
                                          }
                                        >
                                          Live Lecture
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                        >
                                          {field.data.isLiveLecture
                                            ? "Students will join this session online"
                                            : "Enable online live session for this lecture"}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                    <Switch
                                      checked={!!field.data.isLiveLecture}
                                      onChange={(e) =>
                                        handleInputChange(
                                          field.id,
                                          "isLiveLecture",
                                          e.target.checked,
                                          index,
                                        )
                                      }
                                      sx={{
                                        "& .MuiSwitch-switchBase.Mui-checked": {
                                          color: "#f77f00",
                                        },
                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          { backgroundColor: "#f77f00" },
                                      }}
                                    />
                                  </Stack>

                                  <Collapse
                                    in={!!field.data.isLiveLecture}
                                    timeout={400}
                                  >
                                    <Box
                                      sx={{
                                        mt: 3,
                                        pt: 3,
                                        borderTop: "1px dashed #ffe0b2",
                                      }}
                                    >
                                      <Grid container spacing={3}>
                                       
                                        <Grid item xs={12} md={4}>
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="Class Name"
                                            placeholder="e.g. Live Math Session"
                                            value={
                                              field.data.liveClassName || ""
                                            }
                                            onChange={(e) =>
                                              handleInputChange(
                                                field.id,
                                                "liveClassName",
                                                e.target.value,
                                                index,
                                              )
                                            }
                                            required
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <ClassIcon
                                                    sx={{
                                                      color: "#f77f00",
                                                      fontSize: 20,
                                                    }}
                                                  />
                                                </InputAdornment>
                                              ),
                                            }}
                                            sx={{
                                              "& .MuiOutlinedInput-root": {
                                                borderRadius: 2.5,
                                                bgcolor: "white",
                                                transition: "all 0.2s ease",
                                                "& fieldset": {
                                                  borderColor: "#e0e0e0",
                                                  borderWidth: 1.5,
                                                },
                                                "&:hover fieldset": {
                                                  borderColor: "#ffb74d",
                                                },
                                                "&.Mui-focused fieldset": {
                                                  borderColor: "#f77f00",
                                                  borderWidth: 2,
                                                },
                                              },
                                              "& .MuiInputLabel-root": {
                                                color: "#9e9e9e",
                                                fontWeight: 600,
                                                fontSize: "0.95rem",
                                              },
                                              "& .MuiInputLabel-root.Mui-focused":
                                                { color: "#f77f00" },
                                              "& .MuiInputLabel-root.MuiInputLabel-shrink":
                                                {
                                                  fontWeight: 700,
                                                  color: "#e65100",
                                                },
                                            }}
                                          />
                                        </Grid>

                                      
                                        <Grid item xs={12} md={8}>
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="Description"
                                            placeholder="Briefly describe what will be covered in this live session..."
                                            multiline
                                            rows={2}
                                            value={
                                              field.data.liveDescription || ""
                                            }
                                            onChange={(e) =>
                                              handleInputChange(
                                                field.id,
                                                "liveDescription",
                                                e.target.value,
                                                index,
                                              )
                                            }
                                            required
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment
                                                  position="start"
                                                  sx={{
                                                    mt: 1.5,
                                                    alignSelf: "flex-start",
                                                  }}
                                                >
                                                  <Description
                                                    sx={{
                                                      color: "#f77f00",
                                                      fontSize: 20,
                                                    }}
                                                  />
                                                </InputAdornment>
                                              ),
                                            }}
                                            sx={{
                                              "& .MuiOutlinedInput-root": {
                                                borderRadius: 2.5,
                                                bgcolor: "white",
                                                alignItems: "flex-start",
                                                transition: "all 0.2s ease",
                                                "& fieldset": {
                                                  borderColor: "#e0e0e0",
                                                  borderWidth: 1.5,
                                                },
                                                "&:hover fieldset": {
                                                  borderColor: "#ffb74d",
                                                },
                                                "&.Mui-focused fieldset": {
                                                  borderColor: "#f77f00",
                                                  borderWidth: 2,
                                                },
                                              },
                                              "& .MuiInputLabel-root": {
                                                color: "#9e9e9e",
                                                fontWeight: 600,
                                                fontSize: "0.95rem",
                                              },
                                              "& .MuiInputLabel-root.Mui-focused":
                                                { color: "#f77f00" },
                                              "& .MuiInputLabel-root.MuiInputLabel-shrink":
                                                {
                                                  fontWeight: 700,
                                                  color: "#e65100",
                                                },
                                            }}
                                          />
                                        </Grid>
                                      
                                        <Grid item xs={12}>
                                          <Paper
                                            elevation={0}
                                            sx={{
                                              p: 2.5,
                                              borderRadius: 2,
                                              bgcolor: "white",
                                              border: "1px solid #eeeeee",
                                            }}
                                          >
                                            <Typography
                                              variant="subtitle2"
                                              fontWeight={700}
                                              sx={{
                                                mb: 2,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                              }}
                                            >
                                              <Person fontSize="small" />{" "}
                                              Student Access{" "}
                                              <Box
                                                component="span"
                                                sx={{
                                                  color: "error.main",
                                                  ml: 0.3,
                                                }}
                                              >
                                                *
                                              </Box>
                                            </Typography>

                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              spacing={2}
                                              sx={{ mb: 2 }}
                                            >
                                              <Typography
                                                variant="body2"
                                                fontWeight={600}
                                                color={
                                                  field.data.liveStudentMode !==
                                                  "SELECTED"
                                                    ? "#e65100"
                                                    : "text.secondary"
                                                }
                                              >
                                                All Students
                                              </Typography>
                                              <Switch
                                                checked={
                                                  field.data.liveStudentMode ===
                                                  "SELECTED"
                                                }
                                                onChange={(e) => {
                                                  const mode = e.target.checked
                                                    ? "SELECTED"
                                                    : "ALL";
                                                  handleInputChange(
                                                    field.id,
                                                    "liveStudentMode",
                                                    mode,
                                                    index,
                                                  );
                                                  if (!e.target.checked) {
                                                    handleInputChange(
                                                      field.id,
                                                      "liveSelectedStudents",
                                                      [],
                                                      index,
                                                    );
                                                  }
                                                }}
                                                sx={{
                                                  "& .MuiSwitch-switchBase.Mui-checked":
                                                    { color: "#f77f00" },
                                                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                                    {
                                                      backgroundColor:
                                                        "#f77f00",
                                                    },
                                                }}
                                              />
                                              <Typography
                                                variant="body2"
                                                fontWeight={600}
                                                color={
                                                  field.data.liveStudentMode ===
                                                  "SELECTED"
                                                    ? "#e65100"
                                                    : "text.secondary"
                                                }
                                              >
                                                Selected Students Only
                                              </Typography>
                                            </Stack>

                                            <Collapse
                                              in={
                                                field.data.liveStudentMode ===
                                                "SELECTED"
                                              }
                                              timeout={300}
                                            >
                                              <Box>
                                                <Stack
                                                  direction="row"
                                                  spacing={1}
                                                  justifyContent="flex-end"
                                                  sx={{ mb: 1 }}
                                                >
                                                  <Button
                                                    size="small"
                                                    onClick={() =>
                                                      handleInputChange(
                                                        field.id,
                                                        "liveSelectedStudents",
                                                        studentsList.map(
                                                          (s) => s.id,
                                                        ),
                                                        index,
                                                      )
                                                    }
                                                    sx={{
                                                      color: "#f77f00",
                                                      borderColor: "#ffb74d",
                                                      fontSize: "12px",
                                                      textTransform: "none",
                                                      borderRadius: 1.5,
                                                    }}
                                                    variant="outlined"
                                                  >
                                                    Select All
                                                  </Button>
                                                  <Button
                                                    size="small"
                                                    onClick={() =>
                                                      handleInputChange(
                                                        field.id,
                                                        "liveSelectedStudents",
                                                        [],
                                                        index,
                                                      )
                                                    }
                                                    sx={{
                                                      color: "#f77f00",
                                                      borderColor: "#ffb74d",
                                                      fontSize: "12px",
                                                      textTransform: "none",
                                                      borderRadius: 1.5,
                                                    }}
                                                    variant="outlined"
                                                  >
                                                    Unselect All
                                                  </Button>
                                                </Stack>

                                                <FormControl
                                                  fullWidth
                                                  size="small"
                                                >
                                                  <MuiSelect
                                                    multiple
                                                    displayEmpty
                                                    value={
                                                      field.data
                                                        .liveSelectedStudents ||
                                                      []
                                                    }
                                                    onChange={(e) =>
                                                      handleInputChange(
                                                        field.id,
                                                        "liveSelectedStudents",
                                                        e.target.value,
                                                        index,
                                                      )
                                                    }
                                                    renderValue={(selected) => (
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          flexWrap: "wrap",
                                                          gap: 0.5,
                                                          py: 0.5,
                                                        }}
                                                      >
                                                        {selected.length ===
                                                        0 ? (
                                                          <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                          >
                                                            No students selected
                                                          </Typography>
                                                        ) : (
                                                          selected.map(
                                                            (value) => {
                                                              const student =
                                                                studentsList.find(
                                                                  (s) =>
                                                                    s.id ===
                                                                    value,
                                                                );
                                                              return (
                                                                <Chip
                                                                  key={value}
                                                                  label={
                                                                    student?.name ||
                                                                    value
                                                                  }
                                                                  size="small"
                                                                  sx={{
                                                                    bgcolor:
                                                                      "#FFF3E0",
                                                                    color:
                                                                      "#e65100",
                                                                    borderRadius:
                                                                      "8px",
                                                                    fontWeight: 500,
                                                                    fontSize:
                                                                      "0.75rem",
                                                                  }}
                                                                />
                                                              );
                                                            },
                                                          )
                                                        )}
                                                      </Box>
                                                    )}
                                                    sx={{
                                                      borderRadius: 2,
                                                      bgcolor: "white",
                                                    }}
                                                  >
                                                    {studentsList.length ===
                                                      0 && (
                                                      <MenuItem disabled>
                                                        No students found for
                                                        this class & section
                                                      </MenuItem>
                                                    )}
                                                    {studentsList.map(
                                                      (student) => (
                                                        <MenuItem
                                                          key={student.id}
                                                          value={student.id}
                                                        >
                                                          <Checkbox
                                                            checked={
                                                              (
                                                                field.data
                                                                  .liveSelectedStudents ||
                                                                []
                                                              ).indexOf(
                                                                student.id,
                                                              ) > -1
                                                            }
                                                            sx={{
                                                              color: "#f77f00",
                                                              "&.Mui-checked": {
                                                                color:
                                                                  "#f77f00",
                                                              },
                                                            }}
                                                          />
                                                          <Typography variant="body2">
                                                            {student.name} (
                                                            {student.admissionNumber ||
                                                              student.code ||
                                                              student.rollNumber ||
                                                              "N/A"}
                                                            )
                                                          </Typography>
                                                        </MenuItem>
                                                      ),
                                                    )}
                                                  </MuiSelect>
                                                </FormControl>
                                              </Box>
                                            </Collapse>
                                          </Paper>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Collapse>
                                </Box>
                              </Grid> */}
                            </Grid>
                          </CardContent>
                        </Paper>
                      </Grow>
                    ))}

                    {/* Add New Row Button */}
                    {!updateExt &&
                      !uploadLecture &&
                      !timeTableDeletedByDate && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mt: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Add />}
                            onClick={handleAddField}
                            disabled={fields.some(
                              (obj) =>
                                obj?.data?.start_time === obj?.data.end_time,
                            )}
                            sx={{
                              borderRadius: 3,
                              px: 4,
                              py: 1,
                              fontWeight: 700,
                              boxShadow: "0 4px 16px rgba(247,127,0,0.25)",
                            }}
                          >
                            Add New Lecture
                          </Button>
                        </Box>
                      )}
                  </Stack>
                ) : loading ? (
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      py: 8,
                    }}
                  >
                    <img
                      alt="loader"
                      src="/gif/LoaderDot.gif"
                      style={{ width: 180, height: 180 }}
                    />
                  </Box>
                ) : null}
              </Box>
            )}

            {/* Upload Lecture Component */}
            {uploadLecture && <CreateTimeTable />}
          </CardContent>
        </Card>

        {/* ─── Popups / Modals ─── */}
        {showDeletTimeTableByDatePopup && (
          <DeleteSuccessfulTimetableByDate
            isDeletingTimeTable={isDeletingTimeTable}
            setIsDeletingTimeTable={setIsDeletingTimeTable}
            isConfirmation={isConfirmation}
            handleDeleteLactureByDate={handleDeleteLactureByDate}
            setShowDeletTimeTableByDatePopup={setShowDeletTimeTableByDatePopup}
          />
        )}
        {timetableSuccess && (
          <CreateSuccessfulTimeTable
            setTimetableSuccess={setTimetableSuccess}
          />
        )}

        {updateSupplemnts && (
          <UpdateSupplements setUpdateSupplemnts={setUpdateSupplemnts} />
        )}

        {openPopup && (
          <OverLap
            errorMsg={errorMsg}
            setOverLap={setOpenPopup}
            setCreateNew={setCreateNew}
          />
        )}
        {delclick && (
          <DeleteUpdate
            setDelClick={setDelClick}
            delSeriesLecture={delSeriesLecture}
            delThisLecture={delThisLecture}
            delDetails={delDetails}
            onSuccess={async () => {
              toast.success("Lecture deleted successfully");

              await fetchTimetable(formatDate(dateUpdateExt));
              resetUpdatedLectures();
              setDelClick(false);
            }}
          />
        )}
      </Box>
    </ThemeProvider>
  );
}
